import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {JobboardAdapter} from '../adapters/jobboard.adapter';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyInfoResolver {
  private adapter = inject(JobboardAdapter);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.adapter.getCompanyInfo(route.params['companyId']);
  }
}
